<template>
  <div>

    <vx-card card-border class="mb-4" title="Mantenimiento inactivo/activo" title-color="dark" collapseAction>
        <vs-switch v-model="empresa.mantenimiento" @input="setMantenimiento()">
          <template #off>
              Activar
          </template>
          <template #on>
              Desactivar
          </template>
        </vs-switch>
    </vx-card>

    <div class="mb-8">
      <import-excel :onSuccess="loadData" />
    </div>

    <vs-popup :title="popupErrorTitle" :active.sync="popupError" button-close-hidden>
      <div>
        <vs-table :data="mensajesError">
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr]">
                <span v-html="data[indextr]"></span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="popupError=false">Cerrar</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import empresasStore from '@/store/configuracion/empresas/index.js'
import valProductosStore from '@/store/configuracion/val-productos/index.js'
import ImportExcel from '@/components/excel/ImportExcel.vue'

export default {
  components: {
    ImportExcel
  },
  data () {
    return {
      empresa: {},      
      tableData: [],
      header: [],
      fileName: '',
      mensajesError: [],
      popupErrorTitle: null,
      popupError: false
    }
  },
  methods: {
    setMantenimiento () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      delete this.empresa.usuarios
      delete this.empresa.valSectores      
      this.$store.dispatch('empresasStore/updateEmpresa', this.empresa)
        .then((response)   => { 
          let texto = ''
          response.data.mantenimiento === false ? texto = 'Mantenimiento desactivado' : texto = 'Mantenimiento Activado'
          this.showSuccess(texto)          
        })
        .catch((error) => {
          this.showError(error)
        })
    },
    async loadData ({ results, header, file }) {
      // this.header = header
      // this.tableData = results
      this.fileName = file.name
      let fila = 2  // Na primeira fila está os títulos das columnas
      this.mensajesError = []
      const tiposClientes = ['AUTONOMO', 'EMPRESA', 'PARTICULAR']
      const tiposTarjetas = ['MOVIL', 'FIJO', 'COMBO', 'COMBO_TV', 'TV', 'SVA']
      const secciones = ['PRODUCTO_PRINCIPAL', 'PRIMER_MOVIL_ADICIONAL', 'MOVIL_ADICIONAL', 'VALOR_AÑADIDO', 'TV']

      // Verificamos que existan as columnas obligatorias. Así se chaman se exportamos a CSV desde 'Configuración/Productos'
      const existeTipoCliente = header.includes('TIPO_CLIENTE')
      const existeTipoTarjeta = header.includes('TIPO_TARJETA')
      const existeSeccion = header.includes('SECCION')
      const existeImporteSinPromocion = header.includes('IMPORTE_SIN_PROMOCION')
      const existeImporteConPromocion = header.includes('IMPORTE_CON_PROMOCION')

      if (!existeTipoCliente) {
        this.mensajesError.push('<p style="color:red;font-weight: bold;">En el fichero no existe la columna:</p> <strong>"TIPO_CLIENTE"</strong><br>Por favor, revise el fichero.')
      } else if (!existeTipoTarjeta) {
        this.mensajesError.push('<p style="color:red;font-weight: bold;">En el fichero no existe la columna:</p> <strong>"TIPO_TARJETA"</strong><br>Por favor, revise el fichero.')
      } else if (!existeSeccion) {
        this.mensajesError.push('<p style="color:red;font-weight: bold;">En el fichero no existe la columna:</p> <strong>"SECCION"</strong><br>Por favor, revise el fichero.')
      } else if (!existeImporteSinPromocion) {
        this.mensajesError.push('<p style="color:red;font-weight: bold;">En el fichero no existe la columna:</p> <strong>"IMPORTE_SIN_PROMOCION"</strong><br>Por favor, revise el fichero.')
      } else if (!existeImporteConPromocion) {
        this.mensajesError.push('<p style="color:red;font-weight: bold;">En el fichero no existe la columna:</p> <strong>"IMPORTE_CON_PROMOCION"</strong><br>Por favor, revise el fichero.')
      }
      
      // Verificamos que os tipos de cliente e tipos de productos sexan os permitidos, así como que o importe estea correcto (decimais con .)
      results.forEach(element => {
        if (existeTipoCliente && !tiposClientes.includes(element['TIPO_CLIENTE'])) {
          this.mensajesError.push(`<p style="color:red;font-weight: bold;">Error en la fila ${fila}:</p> <strong>Tipo cliente incorrecto.</strong> Los tipos de cliente correctos son:<br>${tiposClientes.join('<br>')}`)
        } 
        if (existeTipoTarjeta && !tiposTarjetas.includes(element['TIPO_TARJETA'])) {
          this.mensajesError.push(`<p style="color:red;font-weight: bold;">Error en la fila ${fila}:</p> <strong>Tipo de tarjeta incorrecto.</strong> Los tipos de tarjetas correctas son:<br>${tiposTarjetas.join('<br>')}`)
        }
        if (existeSeccion && !secciones.includes(element['SECCION'])) {
          this.mensajesError.push(`<p style="color:red;font-weight: bold;">Error en la fila ${fila}:</p> <strong>Sección incorrecta.</strong> Los tipos de secciones correctas son:<br>${secciones.join('<br>')}`)
        }
        if (existeImporteSinPromocion && typeof (element['IMPORTE_SIN_PROMOCION']) !== 'number') {
          this.mensajesError.push(`<p style="color:red;font-weight: bold;">Error en la fila ${fila}:</p> <strong>Importe sin promoción incorrecto.</strong> El importe no tiene un formato numérico. Recuerde que los decimales deben introducirse con "." en lugar de ",".<br>El valor de la celda es: ${element['IMPORTE_SIN_PROMOCION']}`)
        }
        if (existeImporteConPromocion && typeof (element['IMPORTE_CON_PROMOCION']) !== 'number') {
          this.mensajesError.push(`<p style="color:red;font-weight: bold;">Error en la fila ${fila}:</p> <strong>Importe con promoción incorrecto.</strong> El importe no tiene un formato numérico. Recuerde que los decimales deben introducirse con "." en lugar de ",".<br>El valor de la celda es: ${element['IMPORTE_SIN_PROMOCION']}`)
        }
        fila++
      })

      if (this.mensajesError.length > 0) {
        this.showError('Se ha producido un error al procesar el fichero.<br>Revise la lista de errores.')
        this.popupErrorTitle = 'Lista de errores producidos al procesar el fichero'
        this.popupError = true
      } else {
        this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
        const formData = new FormData()
        formData.append('fileInput', file)
        await this.$store.dispatch('valProductosStore/importarValProductos', formData)
          .then((response) => {
            this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
            this.showSuccess('FICHERO PROCESADO', `El fichero ha sido procesado correctamente.<br>Se han insertado ${response.data.total} filas.`)
          })
          .catch((error) => {
            this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
            this.showError('Erro al cargar los datos en base de datos.<br>Revise el popup de errores.')
            this.mensajesError.push(`<p style="color:red;font-weight: bold;">Detalle del error:</p> <strong>${error.response.data['hydra:description']}.</strong><br>Por favor, revise el fichero.`)
            this.popupErrorTitle = 'Error al cargar los datos en base de datos'
            this.popupError = true
            console.log(error)
          })
      }
    },
    showSuccess (titulo, texto) {
      this.$vs.loading.close()
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showError (error) {
      this.$vs.loading.close()
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    }
  },
  async created () {
    if (!valProductosStore.isRegistered) {
      this.$store.registerModule('valProductosStore', valProductosStore)
      valProductosStore.isRegistered = true
    }
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }

    const empresaId = 1
    await this.$store.dispatch('empresasStore/getEmpresa', empresaId)
      .then((response) => {
        this.empresa = response.data        
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>